module.exports = __webpack_public_path__ + "media/nicole7.e5916a4c.mp3";